exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Testimonial__testimonial--db9a32 {\n  background: #FFFFFF;\n  border: 1px solid #cfcfcf;\n  border-radius: 4px;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .3);\n  padding: 16px;\n}\n\n.Testimonial__image--4e7abe {\n  border-radius: 180px;\n  width: 80px;\n  min-width: 80px;\n  height: 80px;\n\n  background-position: center center;\n  background-size: cover;\n}\n\n.Testimonial__member--4e27f1 {\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.Testimonial__info--df6664 {\n  margin-left: 20px;\n}\n\n.Testimonial__name--79ffe6 {\n  font-size: 21px;\n  font-weight: bold;\n  line-height: 1.14;\n  color: #4d4d4d;\n\n  margin-top: 12px;\n  margin-bottom: 12px;\n}\n\n.Testimonial__role--ce8d84 {\n  color: #808080;\n  font-size: 16px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n}\n", ""]);

// exports
exports.locals = {
	"testimonial": "Testimonial__testimonial--db9a32",
	"image": "Testimonial__image--4e7abe",
	"member": "Testimonial__member--4e27f1",
	"info": "Testimonial__info--df6664",
	"name": "Testimonial__name--79ffe6",
	"role": "Testimonial__role--ce8d84"
};


//////////////////
// WEBPACK FOOTER
// /tw-build/dev/global-site/~/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:6]"}!/tw-build/dev/global-site/~/postcss-loader!./component/TeamList/Testimonial.css
// module id = 117
// module chunks = 0